import { getStore } from '../store';

export default () => getStore().TimeFormat;
